/**
 * Zentrale Basis-URL für alle API-Calls.
 *
 * - Dev (vite): default `http://localhost:3000` (lokales NestJS-Backend).
 * - Produktion hinter Apache/Caddy: `VITE_API_BASE=""` setzen → Calls werden
 *   relativ (`/api/...`) und treffen denselben Host (z. B. bafa.die.app), wo
 *   Apache `/api/*` an die NestJS-API reverse-proxied.
 *
 * WICHTIG: Vite substituiert `import.meta.env.VITE_*` zur BUILD-Zeit per
 * statischer String-Pattern-Replacement. Nur die literale Form
 * `import.meta.env.VITE_API_BASE` wird ersetzt — also kein optional chaining
 * dazwischen, kein Type-Cast über `import.meta`.
 */
// @ts-ignore — kein vite-env.d.ts im Projekt
const envBase: string | undefined = import.meta.env.VITE_API_BASE;

export const API_BASE: string = envBase !== undefined ? envBase : 'http://localhost:3000';
